(function () {
    'use strict';

    /*
     UserProfileController Module
    -------------------------------------------------------------------------- */

    angular
        .module('UserApp.profile', [])

        /**
          * UserProfileController - edit user profile
          *
          * @inject __Form
          * @inject appServices
          * 
          * @return void
          *-------------------------------------------------------- */

        .controller('UserProfileController', [
            '__Form',
            'appServices',
            function (__Form, appServices) {

                var scope = this;

                scope = __Form.setup(scope, 'user_profile__form', 'profileData');

                scope.request_completed = false;

                __Form.fetch('user.profile.details').success(function (responseData) {

                    appServices.processResponse(responseData, null, function () {
                        __Form.updateModel(scope, responseData.data.profile);
                        scope.request_completed = true;
                    });

                });

            }

        ]);

})();